import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ProgramBillingEditor.html?raw';
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import NumberInput from '../../moreCore/UI/NumberInput/NumberInput';
import HintBox from '../../moreCore/UI/HintBox/HintBox';
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../moreCore/Tools/EntityStore';
import { DistributionType, EvPlanning, HTEvPlanningCommunication, HtHtEvPlanningCommunicationDistributionType, VatCodes } from "./ProgramBillingEditorTypes";
import _GlobalSelectEntityDialogsMixin from '../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import lang from 'dojo/_base/lang';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import { ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import { SelectEntityDialogTypes } from "../../moreCore/_loadingHelpers/SelectEntityDialog";
import DistributionTypeEditor from './DistributionTypeEditor';
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import Edit from '../../moreCore/UI/Edit/Edit';
import _LabelInputBase from '../../moreCore/UI/_LabelInputBase/_LabelInputBase';

class ProgramBillingEditor extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin, _uiFrameMixin) {
    templateString: any = template;

    private className: string = "ht_evplanning_communication";
    private isNew: boolean;

    private sectionTable: HTMLElement;

    private inputCommunication: MdsLax<InstanceType<typeof HintBox>>;
    private inputEvPlanning: MdsLax<InstanceType<typeof HintBox>>;

    private newDistributionTypeButton: HTMLButtonElement;

    private inputPriceOfSaleGross: MdsLax<InstanceType<typeof NumberInput>>;
    private inputRefVatCode: MdsLax<InstanceType<typeof SearchSelect>>;
    private buttongVatCode: string = "00000124:00000023";
    private inputPriceOfSaleNet: MdsLax<InstanceType<typeof NumberInput>>;
    private inputQuantityDepotStart: MdsLax<InstanceType<typeof NumberInput>>;
    
    private inputQuantityConsumptionInternal: MdsLax<InstanceType<typeof NumberInput>>;
    private inputQuantitySold: MdsLax<InstanceType<typeof NumberInput>>;
    private inputQuantityConsumptionTotal: MdsLax<InstanceType<typeof NumberInput>>;
    private inputQuantityDepotEnd: MdsLax<InstanceType<typeof NumberInput>>;
    private buttonDefaultVat: HTMLButtonElement;
    
    private tableExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private tableContainer: HTMLElement;
    private distributionTypeTable: MdsLax<InstanceType<typeof StaticTable>>;
    private distdistributionTypeStore: MdsLax<InstanceType<typeof EntityStore<HtHtEvPlanningCommunicationDistributionType>>>;

    private vatCodes: Array<VatCodes> = [];

    private rowConfig2: StaticTable.RowConfig = {
        attributes: [
            "ref_distribution_type.is_for_sale",
            "ref_distribution_type.description",
            "revenue_gross_sum_actual",
            "VAT_value_actual",
            "revenue_net_sum_actual"
        ],
        colNamesInternal: [
            "ref_distribution_type.is_for_sale",
            "ref_distribution_type.description",
            "revenue_gross_sum_actual",
            "VAT_value_actual",
            "revenue_net_sum_actual"
        ],
        headings: [
            (this as any).translate("General_Label_IsForSale"),
            (this as any).translate("General_Label_DistributionType"),
            (this as any).translate("General_Label_RevenueGrossSumActual"),
            (this as any).translate("General_Label_VatSum"),
            (this as any).translate("General_Label_RevenueNetSumActual")
        ],
        bgColors: [
            "ref_distribution_type.coloration",
            "ref_distribution_type.coloration",
            "ref_distribution_type.coloration",
            "ref_distribution_type.coloration", 
            "ref_distribution_type.coloration", 
        ]
    }

    private rowConfig1: StaticTable.RowConfig = {
        attributes: [
            "is_oversteered",
            "price_of_sale_gross",
            "quantity",
            //"ref_vat_code.code",
            "note"

        ],
        colNamesInternal: [
            "is_oversteered",
            "price_of_sale_gross",
            "quantity",
            //"ref_vat_code.code",
            "note"
        ],
        headings: [
            (this as any).translate("General_Label_IsOversteered"),
            (this as any).translate("General_Label_PriceOfSaleGross"),
            (this as any).translate("General_Label_Quantity"),
            //this.translate("General_Label_VatCode"),
            (this as any).translate("General_Label_Note")
        ],
        bgColors: [
            null,
            null,
            null,
            //null,
            null
        ],
        colspans: [
            1,
            1,
            1,
            2
        ]
    }
    
    private rowConfig1_old: StaticTable.RowConfig = {
        attributes: [
            "is_oversteered",
            "ref_distribution_type.description",
            "ref_distribution_type.is_for_sale",
            "price_of_sale_gross",
            "quantity",
        ],
        colNamesInternal: [
            "is_oversteered",
            "ref_distribution_type.description",
            "is_for_sale",
            "price_of_sale_gross",
            "quantity",
        ],
        widths: [
            
        ],
        headings: [
            (this as any).translate("General_Label_IsOversteered"),
            (this as any).translate("General_Label_DistributionType"),
            (this as any).translate("General_Label_IsForSale"),
            (this as any).translate("General_Label_PriceOfSaleGross"),
            (this as any).translate("General_Label_Quantity"),
        ],
        bgColors: [
            null,
            "ref_distribution_type.coloration",
            "ref_distribution_type.coloration",
            "ref_distribution_type.coloration",
            null,
        ],
        colspans: [
            1,
            1,
            1,
            1,
            2
        ]
    }

    private rowConfig2_old: StaticTable.RowConfig = {
        attributes: [
            "revenue_gross_sum_actual",
            "ref_vat_code.code",
            "VAT_value_actual",
            "revenue_net_sum_actual"
        ],
        colNamesInternal: [
            "revenue_gross_sum_actual",
            "ref_vat_code.code",
            "VAT_value_actual",
            "revenue_net_sum_actual"
        ],
        widths: [

        ],
        headings: [
            (this as any).translate("General_Label_RevenueGrossSumActual"),
            (this as any).translate("General_Label_VatCode"),
            (this as any).translate("General_Label_VatSum"),
            (this as any).translate("General_Label_RevenueNetSumActual")
        ],
        bgColors: [
            "ref_distribution_type.coloration",
            null,
            "ref_distribution_type.coloration",
            "ref_distribution_type.coloration"

        ]
    }

    private tableLayout: StaticTable.Layout = {
        label: "distributionTypeLTableLayout",
        name: "distributionTypeLTableLayout",
        rows: [(this as any).rowConfig1, (this as any).rowConfig2]
    }

    

    private _tableFormatter(cell: StaticTable.StaticTableCell<HtHtEvPlanningCommunicationDistributionType>) {
        let name = cell.name;
        let entity = cell.entity;
        let value = cell.value;
        let node = cell.tableCellNode;


        switch (name) {
            case "is_oversteered":
                    let inputIsOversteered = new CheckBox();
                    var status = this.getAttributeValue("ref_status_program_accounting");
                    inputIsOversteered.setReadonly((status && status.code === "BEST") || !entity.ref_distribution_type.is_for_sale ? true : false);
                    inputIsOversteered.setValue(entity.is_oversteered, true);
                    inputIsOversteered.on("change", lang.hitch(this, this._onChangeIsOversteered, entity));
                    node.innerHTML = "";
                    inputIsOversteered.placeAt(node);
                    return true;
                break;
            case "price_of_sale_gross":
                if (entity.ref_distribution_type.is_for_sale) {
                    let inputPriceOfSaleGross = new NumberInput();
                    var status = this.getAttributeValue("ref_status_program_accounting");
                    inputPriceOfSaleGross.setReadonly((status && status.code === "BEST") || !entity.is_oversteered ? true : false);
                    //if (!entity.is_oversteered) entity.price_of_sale_gross = this.getAttributeValue("price_of_sale_gross");
                    inputPriceOfSaleGross.setUnit("€");
                    inputPriceOfSaleGross.setPlaces(2);
                    inputPriceOfSaleGross.setStep("0.05");
                    inputPriceOfSaleGross.setValue(entity.price_of_sale_gross, true);
                    inputPriceOfSaleGross.on("change", lang.hitch(this, this._onChangePriceOfSaleGross, entity));
                    node.innerHTML = "";
                    inputPriceOfSaleGross.placeAt(node);
                    return true;
                } else {
                    node.innerHTML = "/";
                }
                break;
            case "quantity":
                let inputQuantity = new NumberInput();
                var status = this.getAttributeValue("ref_status_program_accounting");
                inputQuantity.setReadonly(status && status.code === "BEST" ? true : false);
                inputQuantity.setValue(value, true);
                inputQuantity.on("change", lang.hitch(this, this._onChangeQuantity, entity));
                node.innerHTML = "";
                inputQuantity.placeAt(node);
                return true;
                break;
            case "ref_vat_code.code":
                let inputVatCode = new HintBox();
                var status = this.getAttributeValue("ref_status_program_accounting");
                inputVatCode.setReadonly((status && status.code === "BEST") || !entity.is_oversteered ? true : false);
                inputVatCode.setInputNodeReadonly(true);
                if (entity.is_oversteered) inputVatCode.addInlineButton(lang.hitch(this, this._openSED, "selectVatCode", inputVatCode));
                //else entity.ref_vat_code = this.getAttributeValue("ref_vat_code");
                inputVatCode.setLabelAttribute("code");
                inputVatCode.setValue(entity.ref_vat_code, true);
                //inputVatCode.addInlineButton(lang.hitch(this, this._openSED, inputVatCode));
                inputVatCode.on("change", lang.hitch(this, this._onChangeVatCode, entity));
                node.innerHTML = "";
                inputVatCode.placeAt(node);
                return true;
                break;
            case "note":
                let inputNote = new Edit();
                var status = this.getAttributeValue("ref_status_program_accounting");
                inputNote.setReadonly((status && status.code === "BEST") ? true : false);
                inputNote.setIsMultiline(true, 2);
                inputNote.setValue(entity.note, true);
                inputNote.on("change", lang.hitch(this, this._onChangeNote, entity));
                node.innerHTML = "";
                inputNote.placeAt(node);
                return true;
                break;
            case "VAT_value_actual":
            case "revenue_gross_sum_actual":
            case "revenue_net_sum_actual":
                node.innerHTML = "";
                node.innerHTML = entity.ref_distribution_type.is_for_sale && value !== null && value !== undefined ? parseFloat(value).toFixed(2) + " &#8364;" : "/";
                return true;
                break;
        }

        return false;
    }

    private _onChangeNote(entity: HtHtEvPlanningCommunicationDistributionType, value: string) {
        let updatedEntity = lang.clone(entity);
        updatedEntity.note = value;
        this.distdistributionTypeStore.changeEntry(updatedEntity);
    }

    private _onChangeVatCode(entity: HtHtEvPlanningCommunicationDistributionType, value: VatCodes) {
        let updatedEntity = lang.clone(entity);
        updatedEntity.ref_vat_code = value;
        this._updateValues(updatedEntity);
    }

    private _onChangeQuantity(entity: HtHtEvPlanningCommunicationDistributionType, e: number) {
        let updatedEntity = lang.clone(entity);
        console.log(e);
        updatedEntity.quantity = e;
        this._updateValues(updatedEntity);
    }

    private _onChangePriceOfSaleGross(entity: HtHtEvPlanningCommunicationDistributionType, e: number) {
        let updatedEntity = lang.clone(entity);
        updatedEntity.price_of_sale_gross = e;
        this._updateValues(updatedEntity);
    }

    private _onChangeIsOversteered(entity: HtHtEvPlanningCommunicationDistributionType, isOversteered: boolean) {
        let updatedEntity = lang.clone(entity);
        updatedEntity.is_oversteered = isOversteered;
        if (!isOversteered) {
            updatedEntity.ref_vat_code = this.getAttributeValue("ref_vat_code");
            updatedEntity.price_of_sale_gross = this.getAttributeValue("price_of_sale_gross");
            this._updateValues(updatedEntity);
        } else {
            this.distdistributionTypeStore.changeEntry(updatedEntity);

        }
    }

    private _updateValues(entity: HtHtEvPlanningCommunicationDistributionType) {
        let updatedEntity = lang.clone(entity);

        if (!entity.ref_distribution_type.is_for_sale) {
            this.distdistributionTypeStore.changeEntry(updatedEntity);
            return;
        }

        let newGrossPrice = entity.price_of_sale_gross;
        let vatCode = entity.ref_vat_code;
        let vat = vatCode.VAT_value;


        let newNetPrice = Math.round((newGrossPrice * 100) / (100 + vat) * 100) / 100;
        entity.price_of_sale_net = newNetPrice;

        let quantity = entity.quantity;

        let newRevenueGrossSumActual = quantity * newGrossPrice;
        let newRevenueNetSumActual = quantity * newNetPrice;
        let newVatValueActual = newRevenueGrossSumActual - newRevenueNetSumActual;

        entity.VAT_value_actual = newVatValueActual;
        entity.revenue_gross_sum_actual = newRevenueGrossSumActual;
        entity.revenue_net_sum_actual = newRevenueNetSumActual;

        this.distdistributionTypeStore.changeEntry(entity);
    }

    private _setupTable() {
        this.distributionTypeTable = new StaticTable;
        this.distributionTypeTable.addLayout(this.tableLayout);
        this.distributionTypeTable.setFormatter(lang.hitch(this, this._tableFormatter));
        this.distributionTypeTable.setupFromStore(this.distdistributionTypeStore);

        this.distributionTypeTable.addDefaultRowActionButton("delete");
        this.distributionTypeTable.setCyAttribute("ProgramBillingDistributionTypeTable");
        //this.distributionTypeTable.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEdit));
        //this.distributionTypeTable.setRowClick(lang.hitch(this, this._onClickRow));
        this.UiModder.domConstruct.place(this.distributionTypeTable.domNode, this.tableContainer);
    }


    openEditor(entityID?: string, tabContainer?: string) {
        this.internalName = entityID ? `program_billing_${entityID}` : `new_${Math.random() * 1000000000}`;
        this.show("tab", entityID ? this.translate("General_Loading") : this.translate("General_Label_New") + ": " + this.translate("General_Label_ProgramBilling"), tabContainer);

        this.setAttributeValue("ditstributionTypeDiffData", null);
        this.resetDirty();

        this.setStartupState("ready");

        this.createDefaultButton("save", lang.hitch(this, this._saveEnityData), false);
        

        if (entityID) {
            this.entityId = entityID;
            this._loadEntityData(entityID);
            this.isNew = false;
        } else {
            this.isNew = true;
            this._loadVatCodes();
        }
    }

    private _onClickRow(data: StaticTable.StaticTableRow<HtHtEvPlanningCommunicationDistributionType>) {
        let entity = data.rowGroup.entity;
        this._openDistributionTypeEditor(entity);
    }

    private _onClickEdit(data: StaticTable.StaticTableRowGroup<HtHtEvPlanningCommunicationDistributionType>) {
        let entity = data.entity;
        this._openDistributionTypeEditor(entity);
    }

    private _openDistributionTypeEditor(data: HtHtEvPlanningCommunicationDistributionType) {
        let editor = new DistributionTypeEditor();
        editor.on("confirm", lang.hitch(this, this._onEditorConfirmed));

        editor.openEditor(data);
    }

    private _onEditorConfirmed(data: HtHtEvPlanningCommunicationDistributionType) {
        this.distdistributionTypeStore.changeEntry(data, true);
    }

    private _reload() {
        this._loadEntityData(this.entityId);
        
    }

    private _delete() {

        if (this.distdistributionTypeStore.getCurrentCompleteList().length > 0 || this.distdistributionTypeStore.getDiffData().deleted.length > 0) {
            this.showToast(this.translate("ProgramBillingEditor_Error_StoreNotEmpty"), "fas fa-exclamation-triangle");
            return;
        }

        this.StandbyStart();

        let requestData = {
            entityId: this.entityId,
            className: this.className
        }

        this.RequestManager.callfunction("Webtool_API__ProgramBillingEditor_DeleteEntity", requestData, lang.hitch(this, this._onDeleteResponse), lang.hitch(this, this._onDeleteError));


    }

    private _onDeleteResponse(response) {
        this.StandbyStop();
        this.close();
    }

    private _onDeleteError(error) {
        this.StandbyStop();
        console.error(error);
    }

    private _loadEntityData(entityId: string) {
        this.StandbyStart();

        this.requestContextButtonDisable("save", true);
        this.requestContextButtonDisable("rollback", true); 

        let requestData = {
            entityId: entityId,
            className: this.className
        }

        this.RequestManager.callfunction("Webtool_API__ProgramBillingEditor_LoadEntity", requestData, lang.hitch(this, this._onLoadEntityDataResponse), lang.hitch(this, this._onLoadEntityDataError));
    }

    private _onLoadEntityDataResponse(response: HTEvPlanningCommunication) {
        this.hideNode(this.sectionTable, false);
        this.isNew = false;

        this.createDefaultButton("rollback", lang.hitch(this, this.rollback), false);
        this.createDefaultButton("reload", lang.hitch(this, this._reload));
        this.createDefaultButton("delete", lang.hitch(this, this._delete));

        this.setAttributeValue("ditstributionTypeDiffData", null);

        this.StandbyStop();
        this.setData(response);

        this.setTitles(response.$Displayname, response.$Displayname);

    }

    private _onLoadEntityDataError(error) {
        this.StandbyStop();
        console.error(error);

    }

    protected onDirtyChange(newState: boolean) {

        this.requestContextButtonDisable("save", !newState);
        this.requestContextButtonDisable("rollback", !newState);
    }

    private _onChangeQuantityDepotStart() {      
        let quantityDepotStart = this.getAttributeValue("qty_depot_start");
        let quantityTotal = this.getAttributeValue("qty_consumption_total");
        this.setAttributeValue("qty_depot_end", quantityDepotStart - quantityTotal);
    }


    private _onChangeStore() {
        let completeList = this.distdistributionTypeStore.getCurrentCompleteList();
        let diffData = this.distdistributionTypeStore.getDiffData();

        this.tableExpander.setMarking(completeList.length > 0 ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        this.setAttributeValue("ditstributionTypeDiffData", diffData);

        this._updateQuantities();
    }

    private _updateQuantities() {
        let completeList = this.distdistributionTypeStore.getCurrentCompleteList();

        let quantitySold = 0;
        let quantityInternal = 0;
        for (let item of completeList) {
            if (item.ref_distribution_type.is_for_sale) quantitySold += item.quantity;
            else quantityInternal += item.quantity;
        }
        let total = quantityInternal + quantitySold;
        let depotEnd = this.getAttributeValue("qty_depot_start") - total; 

        this.setAttributeValue("qty_consumption_internal", quantityInternal);
        this.setAttributeValue("qty_sold", quantitySold);
        this.setAttributeValue("qty_consumption_total", total);
        this.setAttributeValue("qty_depot_end", depotEnd);

        //this.inputQuantityConsumptionInternal.setValue(quantityInternal);
        //this.inputQuantitySold.setValue(quantitySold);
        //this.inputQuantityConsumptionTotal.setValue(total);
        //this.inputQuantityDepotEnd.setValue(depotEnd);
    }

    private _onChangePriceOrVat(e) {
        let newGrossPrice = this.getAttributeValue("price_of_sale_gross");
        let vatCode = this.getAttributeValue("ref_vat_code") as VatCodes;
        let vat = vatCode ? vatCode.VAT_value : 0;
        

        let newNetPrice = Math.round((newGrossPrice * 100) / (100 + vat) * 100) / 100;

        this.setAttributeValue("price_of_sale_net", newNetPrice);

        this._updatedStoreItems(newGrossPrice, newNetPrice, vatCode);
    }

    private _updatedStoreItems(grossPrice: number, netPrice: number, vatCode: VatCodes) {
        let completeList = this.distdistributionTypeStore.getCurrentCompleteList();

        for (let item of completeList) {
            let updatedItem = lang.clone(item);

            updatedItem.ref_ht_evplanning_communication.price_of_sale_gross = grossPrice;
            updatedItem.ref_ht_evplanning_communication.ref_vat_code = vatCode;

            if (item.ref_distribution_type.is_for_sale && !item.is_oversteered) {
                
                updatedItem.price_of_sale_gross = grossPrice;
                updatedItem.price_of_sale_net = netPrice;
                updatedItem.ref_vat_code = vatCode;

                if (updatedItem.quantity !== null && updatedItem.quantity !== undefined) {
                    let quantity = updatedItem.quantity;
                    let newRevenueGrossSumActual = quantity * grossPrice;
                    let newRevenueNetSumActual = quantity * netPrice;
                    let newVatValueActual = newRevenueGrossSumActual - newRevenueNetSumActual;

                    updatedItem.revenue_gross_sum_actual = newRevenueGrossSumActual;
                    updatedItem.revenue_net_sum_actual = newRevenueNetSumActual;
                    updatedItem.VAT_value_actual = newVatValueActual;
                }
                


            }
            this.distdistributionTypeStore.changeEntry(updatedItem, true);
        }
    }

    private setReadOnly(isReadonly: boolean) {
        this.inputCommunication.setReadonly(isReadonly);
        this.inputEvPlanning.setReadonly(isReadonly);
        this.inputRefVatCode.setReadonly(isReadonly);
        this.inputPriceOfSaleGross.setReadonly(isReadonly);
        this.inputQuantityDepotStart.setReadonly(isReadonly);
        this.disableNode(this.buttonDefaultVat, isReadonly);

        this.hideNode(this.newDistributionTypeButton, isReadonly);
        this.distributionTypeTable.enableActionButton("edit", null, !isReadonly, !isReadonly);
        this.distributionTypeTable.enableActionButton("delete", null, !isReadonly, !isReadonly);
    }

    protected _onChanged(attribute: string, value: any) {
            switch (attribute) {
                case "ref_vat_code":
                case "price_of_sale_gross":
                    this._onChangePriceOrVat(null);
                    break;
                case "qty_depot_start":
                    this._onChangeQuantityDepotStart();
                    break;
                case "ref_communication":
                case "ref_ev_planning":
                    var completeList = this.distdistributionTypeStore.getCurrentCompleteList();

                    console.log(value, attribute);
                    for (let item of completeList) {
                        let newEntry = lang.clone(item);
                        newEntry.ref_ht_evplanning_communication[attribute] = value;
                        this.distdistributionTypeStore.changeEntry(newEntry, true);
                    }
                    break;
                case "ref_status_program_accounting":
                    var isReadonly = value.code === "BEST";
                    this.setReadOnly(isReadonly);
                    this.distributionTypeTable.updateTable();
                    break;
            }
    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        let distributionTypeList = this.getAttributeValue("EL_ht_ht_ev_planning_communication_distribution_ty");
        this.distdistributionTypeStore.setup(distributionTypeList);
        this.distributionTypeTable.setupFromStore(this.distdistributionTypeStore);

        this.tableExpander.setMarking(distributionTypeList.length > 0 ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        this.tableExpander.toggleExpand(distributionTypeList.length > 0);

        let vatCode = this.getAttributeValue("ref_vat_code");
        this._loadVatCodes(vatCode);

        var status = this.getAttributeValue("ref_satus_program_accounting");
        if (status) {
            var isReadonly = status.code === "BEST";
            this.setReadOnly(isReadonly);
        }
    }


    private _saveEnityData() {
        let requestData = {
            entityId: this.entityId,
            className: this.className,
            isNew: this.isNew,
            changedData: this.changedData
        }

        this.requestContextButtonDisable("save", true);
        this.StandbyStart();

        this.RequestManager.callfunction("Webtool_API__ProgramBillingEditor_SaveEntity", requestData, lang.hitch(this, this._onSaveEntityDataResponse), lang.hitch(this, this._onSaveEntityDataError))
    }

    private _onSaveEntityDataResponse(response) {
        this.StandbyStop();
        this.entityId = response.entityId;
        this._loadEntityData(this.entityId);
    }

    private _onSaveEntityDataError(error) {
        this.StandbyStop();
        console.error(error);
    }

    private _onClickVatButton(e) {
        this.inputRefVatCode.setValue(this.buttongVatCode);
    }

    private _openSED(mode: string, input: MdsLax<InstanceType<ReturnType<typeof _LabelInputBase>>>, e ) {
        this.openSelectEntityDialog(e, mode, lang.hitch(this, this._onSEDCallback, input));
    }

    private _onSEDCallback(input: MdsLax<InstanceType<ReturnType<typeof _LabelInputBase>>>, mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<DistributionType | EvPlanning>>) {
        if (!(items && items.length === 1)) return;

        switch (mode) {
            case "distributionType":
                let distributionType = items[0].entry.data as DistributionType
                let htHtEvPlanningCommunicationDistributionType: HtHtEvPlanningCommunicationDistributionType = {
                    ref_distribution_type: distributionType,
                    $Displayname: "",
                    Classname: "distribution_type",
                    ClassPrintname: "",
                    ID: "" + Math.random() * 10000000000000,
                    is_for_sale: distributionType.is_for_sale,
                    is_oversteered: false,
                    note: "",
                    price_of_sale_gross: distributionType.is_for_sale ? this.getAttributeValue("price_of_sale_gross") : null,
                    price_of_sale_net: distributionType.is_for_sale ? this.getAttributeValue("price_of_sale_net") : null,
                    quantity: null,
                    ref_ht_evplanning_communication: this.getAttributeValue("___root"),
                    ref_vat_code: distributionType.is_for_sale ? this.getAttributeValue("ref_vat_code") : null,
                    revenue_gross_sum_actual: distributionType.is_for_sale ? 0 : null,
                    revenue_net_sum_actual: distributionType.is_for_sale ? 0 : null,
                    VAT_value_actual: distributionType.is_for_sale ? 0 : null
                }

                this.distdistributionTypeStore.addEntry(htHtEvPlanningCommunicationDistributionType);
                break;
            case "communication":
                this.inputCommunication.setValue(items[0].entry.data);
                break;
            case "evPlanning":
                this.inputEvPlanning.setValue(items[0].entry.data);
                break;
            case "selectVatCode":
                input.setValue(items[0].entry.data);
                break;
            default:
                console.error("Illegal SED mode");
                break;
        }
    }

    private _loadVatCodes(presetValue?: VatCodes) {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__ProgramBillingEditor_GetVatCodes", {}, lang.hitch(this, this._onResponseLoadVatCodes, presetValue), lang.hitch(this, this._onErrorLoadVatCodes));
    }

    private _onResponseLoadVatCodes(presetValue: VatCodes, response: Array<VatCodes>) {
        this.StandbyStop();
        let suppress = presetValue === null || presetValue === undefined;
        this.inputRefVatCode.setData(presetValue, response, true, "description", "ID");
        this.vatCodes = response;
    }

    private _onErrorLoadVatCodes(error) {
        console.log(error);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API__ProgramBillingEditor_SED_GetConfig";

        this.inputPriceOfSaleGross.setUnit("€");
        this.inputPriceOfSaleGross.setNumberType("currency");

        this.inputPriceOfSaleNet.setUnit("€");
        this.inputPriceOfSaleNet.setNumberType("currency");

        this.newDistributionTypeButton.addEventListener("click", lang.hitch(this, this._openSED, "distributionType"));
        this.inputCommunication.addInlineButton(lang.hitch(this, this._openSED, "communication"));
        this.inputEvPlanning.addInlineButton(lang.hitch(this, this._openSED, "evPlanning"));

        this.distdistributionTypeStore = new EntityStore();
        this.distdistributionTypeStore.on("change", lang.hitch(this, this._onChangeStore));
        this._setupTable();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ProgramBillingEditor);